import { createContext, ReactNode, useEffect, useState } from 'react';

export type MessagesContextType = {
  cancellationRequested: boolean;
  cancellationRequestHandled: () => void;
};

export const MessagesContext = createContext<MessagesContextType | undefined>(
  undefined
);

interface MessagesContextProviderProps {
  children: ReactNode;
}

export const MessagesContextProvider: React.FC<MessagesContextProviderProps> = (
  props: MessagesContextProviderProps
) => {
  const [cancellationRequested, setCancellationRequested] =
    useState<boolean>(false);

  /* Listen for message events and process them accordingly. */
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleMessage = (event: any) => {
      if (event.data.source === 'mchs-scheduling-host') {
        if (
          event.data.event &&
          event.data.event === 'canceling'
        ) {
          setCancellationRequested(true);
        }
      }
    };

    window.addEventListener('message', handleMessage, false);

    return (): void => {
      window.removeEventListener('message', handleMessage, false);
    };
  }, []);

  function cancellationRequestHandled(): void {
    setCancellationRequested(false);
  }

  return (
    <MessagesContext.Provider
      value={{
        cancellationRequested: cancellationRequested,
        cancellationRequestHandled: cancellationRequestHandled,
      }}
    >
      {props.children}
    </MessagesContext.Provider>
  );
};
